import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FilterQuestionsService {

  // possible filter values are 'all', 'ungraded'
  private initialFilterValue = 'ungraded';

  private filterValue = new BehaviorSubject<any>(this.initialFilterValue);
  currentFilterValue = this.filterValue.asObservable();

  constructor() { }

  setFilterValue = (filterValue) => {
    this.filterValue.next(filterValue);
  }

  getFilerValue = () => {
    return this.filterValue.value;
  }
}
